<template>
  <div class="container">
    <b-modal no-close-on-backdrop centered ref="modal-confirm-fad" hide-footer id="modal-confirm-fad">
      <div v-if="loading">
        <div id="loader">
          <font-awesome-icon icon="spinner" spin />
        </div>
      </div>

      <h4 class="text-center">¿Está seguro de enviar a FAD? El cliente será notificado.</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-fad')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="sendToFad()">OK</b-button>
    </b-modal>

    <h4 class="cardD">Firma Digital</h4>

    <div class="mt-4">
      <div class="row">
        <div class="col-12">
          <b-button
            type="button"
            block
            class="btn-fill orange-btn bottom2"
            size="m"
            @click="openSendToFadModal()"
            :disabled="false && isButtonEnviarAFadDisabledComputed"
          >
            Enviar a FAD
          </b-button>
        </div>
      </div>
    </div>

    <div class="mt-4" v-if="notificacion.staff">
      <div class="">
        <b-button
          type="submit"
          class="btn-fill orange-btn bottom2"
          size="m"
          :disabled="
            notificacion.id_estatus == 11 ||
            notificacion.id_estatus == 12 ||
            notificacion.id_estatus == 13 ||
            notificacion.id_estatus == 23
          "
        >
          Verificar firma
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { FuncionesApi, FadProcesosApi } from "@/api";

export default {
  name: "Fad",

  created() {
    this.fetchFadProcesos()
      .then(() => {
        this.isSentToFad = this.fadProcesos.length > 0 && this.fadProcesos.some((f) => f.cat_fad_responses_id != "5");
      })
      .catch((error) => {
        console.log(error);
        this.$toast.error("Ocurrió un error al cargar la información.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      });
  },

  props: {
    notificacion: { type: Object },
  },

  data() {
    return {
      loading: false,
      isSentToFad: false,

      fadProcesos: [],
    };
  },

  computed: {
    isButtonEnviarAFadDisabledComputed() {
      if (
        this.isSentToFad ||
        this.notificacion.id_estatus == 11 ||
        this.notificacion.id_estatus == 12 ||
        this.notificacion.id_estatus == 13 ||
        this.notificacion.id_estatus == 23
      ) {
        return true;
      }

      return false;
    },
  },

  methods: {
    async fetchFadProcesos() {
      if (!this.notificacion.id) {
        return;
      }

      const { value } = await FadProcesosApi.list({
        cat_servicios_id: 2,
        proceso_id: this.notificacion.id,
      });

      this.fadProcesos = value;

      return this.fadProcesos;
    },

    async sendToFad() {
      try {
        this.loading = true;

        const dataFad = {
          proceso_id: this.notificacion.id,
          cat_servicios_id: 2,
        };

        await FuncionesApi.sendKycsFad(dataFad);

        this.isSentToFad = true;

        this.$toast.success("Documentos enviados a firma", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } catch (error) {
        console.log(error);

        let message = "Sucedió un error con el servicio de FAD.";

        if (error.data?.message) {
          message = error.data.message;
        }

        this.$toast.error(message, {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.hideSendToFadModal();
        this.loading = false;
      }
    },

    openSendToFadModal() {
      this.$refs["modal-confirm-fad"].show();
    },

    hideSendToFadModal() {
      this.$refs["modal-confirm-fad"].hide();
    },
  },
};
</script>
